module.exports = __webpack_public_path__ + "static/media/hiro_img.42e5f8e9.png";